import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker';
import { InfoField } from './InfoField';

import { RequiredField } from '../others/RequiredField';

export const TimeField = props => {
  const { field, formik, getFieldCallback } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl style={{ paddingBottom: 15 }} fullWidth>
        <Typography variant="subtitle1" style={{ paddingBottom: 15 }}>
          <b>{field.label}</b>
          <RequiredField required={field.required} isEmpty={!_.isDate(formik.values[field.name])} />
        </Typography>
        <TimePicker
          inputFormat="hh:mm"
          mask="__:__"
          ampmInClock={false}
          ampm={false}
          autoOk
          name={field.name}
          label={!_.isDate(formik.values[field.name]) ? field.placeholder : null}
          value={formik.values[field.name]}
          onChange={val => formik.setFieldValue(field.name, val)
          }
          error={
            formik.touched[field.name] && Boolean(formik.errors[field.name])
          }
          helperText={formik.touched[field.name] && formik.errors[field.name]}
          renderInput={props => <TextField variant="standard" onKeyDown={e => e.preventDefault()} {...props} />}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
        />
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
            : null
        }
      </FormControl>
    </LocalizationProvider>
  );
};
